import { TApplicationState } from 'shared/types/redux';

export function promoOpenSelector(state: TApplicationState) {
  return state.promo.isOpen;
}
